import React from 'react'

import { ComponentCTALink } from '../../../components/landing/display'

const testimonials = [
  // 1
  {
    name: 'Jacob Stammers',
    affiliation: {
      text: 'The Barn at Heathcote',
    },
    avatar: {
      thumbMd:
        'https://assets.riparide.com/landing_pages/list-with-us/testimonials/jacob_stammers.jpg',
    },
    text:
      'Riparide guests seem to be chilled humans who understand the quirks of our property and really embrace the experience!',
    CTA: (
      <ComponentCTALink url="/stories/92-barn-country">
        View Story
      </ComponentCTALink>
    ),
  },

  // 2
  {
    name: 'Andy Matenson',
    affiliation: {
      text: 'The Water Cabin',
    },
    avatar: {
      thumbMd:
        'https://assets.riparide.com/landing_pages/list-with-us/testimonials/andy_matenson.jpg',
    },
    text:
      'The Riparide site is very user-friendly and their fees are transparent and very reasonable for both host and guest.',
    CTA: (
      <ComponentCTALink url="/stories/727-serenity-by-the-water">
        View Story
      </ComponentCTALink>
    ),
  },

  // 3
  {
    name: 'Fay Bushby',
    affiliation: {
      text: 'Bushies Love Shack',
    },
    avatar: {
      thumbMd:
        'https://assets.riparide.com/landing_pages/list-with-us/testimonials/fay_bushby.jpg',
    },
    text:
      'The Riparide team are so helpful and for someone who is computer illiterate, I find their platform very easy to use. I couldn’t recommend them more!',
    CTA: (
      <ComponentCTALink url="/stories/575-lovers-getaway">
        View Story
      </ComponentCTALink>
    ),
  },

  // 4
  {
    name: 'Barry & Christine',
    affiliation: {
      text: 'The Canvas Barn B&B',
    },
    avatar: {
      thumbMd:
        'https://assets.riparide.com/landing_pages/list-with-us/testimonials/barry_and_christina.jpg',
    },
    text:
      'Doing stories about our property has proved to be very beneficial to our booking numbers - the majority of our bookings are now through Riparide.',
    CTA: (
      <ComponentCTALink url="/stories/401-cosy-in-warburton">
        View Story
      </ComponentCTALink>
    ),
  },

  // 5
  {
    name: 'Lisa Deppeler',
    affiliation: {
      text: 'Aire River Escape',
    },
    avatar: {
      thumbMd:
        'https://assets.riparide.com/landing_pages/list-with-us/testimonials/lisa_deppeler.jpg',
    },
    text:
      ' I like the idea that I am providing a unique experience and adventure for young people who need to get out of the city and do something different.',
    CTA: (
      <ComponentCTALink url="/stories/91-the-aire-down-there">
        View Story
      </ComponentCTALink>
    ),
  },
]

export default testimonials
